module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Therapeuten.797d1404.jpg";